"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueParamsName = exports.thingHtgSubLocalHeatingTypes = exports.styles = exports.packagePrefix = exports.packageKey = exports.fileFormat = exports.fieldsConfig = exports.defaultImgPath = exports.defaultImgFile = exports.configTabs = exports.configComponentTitle = exports.colors = void 0;
var _paulCorePackage = require("paul-core-package");
const {
  ComponentTypes
} = _paulCorePackage.constants;
const packageKey = 'paul_widget_component_details_package';
exports.packageKey = packageKey;
const packagePrefix = '_P_COMPONENT_DETAILS';

/** @todo move to core */
exports.packagePrefix = packagePrefix;
const fileFormat = {
  webp: 'webp'
};
exports.fileFormat = fileFormat;
const defaultImgPath = '/images/default_img';
exports.defaultImgPath = defaultImgPath;
const defaultImgFile = {
  [ComponentTypes.PwcPoe]: '201_point_of_entry.jpg',
  [ComponentTypes.PwhSupply]: '205_storage_water_heater.jpg',
  [ComponentTypes.HtgCc]: '209_storage_charging_pump.jpg',
  [ComponentTypes.HtgHs]: '304_hydraulic_switch.jpg',
  [ComponentTypes.HtgHx]: '320_heat_circulation_pump.jpg',
  [ComponentTypes.PwhC]: '206_circulation_pump.jpg',
  [ComponentTypes.HtgSys]: '312_boiler_gas.jpg',
  [ComponentTypes.HtgSub]: '312_boiler_gas.jpg'
};
exports.defaultImgFile = defaultImgFile;
const configComponentTitle = {
  [ComponentTypes.PwcPoe]: [],
  [ComponentTypes.PwhSupply]: ['thingPwhSupplyManufacturer', 'thingPwhSupplyModel'],
  [ComponentTypes.HtgCc]: ['thingHtgCcPumpManufacturer', 'thingHtgCcPumpModel'],
  [ComponentTypes.HtgHx]: ['thingHtgHxPumpManufacturer', 'thingHtgHxPumpModel'],
  [ComponentTypes.PwhC]: ['thingPwhCPumpManufacturer', 'thingPwhCPumpModel'],
  [ComponentTypes.HtgSys]: ['thingBoilerManufacturer', 'thingBoilerModel'],
  [ComponentTypes.HtgSub]: ['thingHtgSubManufacturer', 'thingHtgSubModel'],
  [ComponentTypes.HtgHs]: ['thingHtgHsManufacturer', 'thingHtgHsModel']
};
exports.configComponentTitle = configComponentTitle;
const fieldsConfig = {
  PwhSupply: {
    thingPwhSupplyCapacity: 42,
    // Volume
    thingPwhSupplyDeviceType: 43 // Storage type
  },

  HtgCc: {
    thingHtgCcNominalDiameterFlow: 44 // Nominal diameter
  },

  HtgHs: {
    thingHtgHxNominalDiameterFlow: 45 // Material flow,
  },

  HtgHx: {
    thingHtgHxNominalDiameterFlow: 46 // Nominal diameter flow
  },

  PwhC: {
    thingPwhCPumpMaximumFlowRate: 47 // Nominal diameter
  },

  HtgSys: {
    thingHtgSysHeatGenerator: 48,
    // Heat generator
    thingHtgSysEnergySource: 49,
    // Energy source
    thingHtgSysNominalHeatOutput: 50 // Nominal heat output
  },

  HtgSub: {},
  Burner: {
    // HtgSys subtype
    thingHtgSysHeatGenerator: 52,
    // Heat generator
    thingHtgSysEnergySource: 53,
    // Energy source
    thingHtgSysNominalHeatOutput: 54 // Nominal heat output
  }
};
exports.fieldsConfig = fieldsConfig;
const configTabs = {
  [ComponentTypes.PwcPoe]: {
    images: {
      tNameKey: 55,
      name: 'Images',
      id: 'images',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'images',
  },

  [ComponentTypes.PwhSupply]: {
    // images: { // for test
    //     name: "Images",
    //     id: 'images',
    //     disabled: false,
    // },
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'details',
  },

  [ComponentTypes.HtgCc]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'details',
  },

  [ComponentTypes.HtgHs]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'details',
  },

  [ComponentTypes.HtgHx]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'details',
  },

  [ComponentTypes.PwhC]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
    // 'details',
  },

  [ComponentTypes.HtgSys]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
  },
  [ComponentTypes.HtgSub]: {
    details: {
      tNameKey: 16,
      name: 'Product details',
      id: 'details',
      disabled: false
    },
    charts: {
      tNameKey: 17,
      name: 'Linecharts',
      id: 'charts',
      disabled: false
    }
  }
};

/** @todo: colors object should be deleted after installing MUI Theme and refactoring components to use theme colors */
exports.configTabs = configTabs;
const colors = {
  'main-color-cl-01': '#00205B',
  'main-color-cl-01-hover': '#002B7A',
  'main-color-cl-02': '#2D78C6',
  'main-color-cl-03': '#37AFEB',
  'main-color-cl-04': '#81D1F7',
  'main-color-cl-05': '#BBE9FF',
  'main-color-cl-06': '#E3F7FF',
  'main-color-cl-07': '#F6F8FC',
  'main-color-cl-08': '#FFFFFF',
  'main-color-cl-09': '#F3F3F3',
  'main-color-cl-10': '#212134',
  'main-color-cl-11': '#32324D',
  'main-color-cl-12': '#4A4A6A',
  'main-color-cl-13': '#666687',
  'main-color-cl-14': '#8E8EA9',
  'main-color-cl-15': '#A5A5BA',
  'main-color-cl-16': '#C0C0CF',
  'main-color-cl-17': '#DCDCE4',
  'main-color-cl-18': '#EAEAEF',
  'main-color-cl-19': '#F6F6F9',
  'main-color-cl-20': '#00BC4B',
  'main-color-cl-21': '#D02B20',
  'main-color-cl-22': '#F29D41',
  'main-color-cl-30': '#0000FF',
  'main-color-cl-31': '#1CE783',
  'main-color-cl-32': '#EFEFED',
  'main-color-cl-40': '#E5E5E7',
  'main-color-cl-90': 'rgba(#FF00FF, 0.3)',
  'main-color-cl-91': '#FF00FF',
  'main-color-cl-92': '#FCFCFD',
  'main-color-cl-93': '#FF8000',
  'main-color-cl-94': '#E71D1C',
  'main-color-cl-95': '#101828',
  'main-color-cl-96': '#000033',
  'main-color-cl-97': '#000066',
  'main-color-cl-98': '#475467',
  'main-color-cl-99': '#667085',
  'main-color-cl-100': '#98a2b3'
};
/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
exports.colors = colors;
const styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  }
};

/**
 @todo: move to core valueParamsName
 **/
exports.styles = styles;
const valueParamsName = {
  value: "value",
  valueType: "valueType",
  temperatureStatus: "temperatureStatus",
  unit: "unit"
};
exports.valueParamsName = valueParamsName;
const thingHtgSubLocalHeatingTypes = {
  direct: 2,
  indirect: 1
};
exports.thingHtgSubLocalHeatingTypes = thingHtgSubLocalHeatingTypes;